import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-mouse",
  "use": "icon-th-mouse-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-mouse\">\n<path d=\"M18 2H14C11.879 2.00232 9.84549 2.84591 8.3457 4.3457C6.84591 5.84549 6.00232 7.87898 6 10V22C6.00232 24.121 6.84591 26.1545 8.3457 27.6543C9.84549 29.1541 11.879 29.9977 14 30H18C20.121 29.9977 22.1545 29.1541 23.6543 27.6543C25.1541 26.1545 25.9977 24.121 26 22V10C25.9977 7.87898 25.1541 5.84549 23.6543 4.3457C22.1545 2.84591 20.121 2.00232 18 2ZM24 10V13H17V4H18C19.5908 4.00165 21.116 4.63433 22.2408 5.75919C23.3657 6.88405 23.9983 8.40921 24 10ZM14 4H15V13H8V10C8.00165 8.40921 8.63433 6.88405 9.75919 5.75919C10.884 4.63433 12.4092 4.00165 14 4ZM18 28H14C12.4092 27.9983 10.884 27.3657 9.75919 26.2408C8.63433 25.116 8.00165 23.5908 8 22V15H24V22C23.9983 23.5908 23.3657 25.116 22.2408 26.2408C21.116 27.3657 19.5908 27.9983 18 28Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-mouse.svg
// module id = YdWh
// module chunks = 84